import withStore, {
  TPresentable,
  TLoadingAwarePresenter
} from "../../core/presenter/withStore";
import Application from "../../Application";
import GetAllCaseDecisionTypesInteractor from "../interactor/GetAllCaseDecisionTypesInteractor";
import CreateCaseDecisionTypeInteractor from "../interactor/CreateCaseDecisionTypeInteractor";
import ShowSuccessMessageInteractor from "../../core/interactor/notifications/ShowSuccessMessageInteractor";
import UpdateCaseDecisionTypeInteractor from "../interactor/UpdateCaseDecisionTypeInteractor";
import { IDocumentType } from "../../documentTypes/model/DocumentType";

export interface TCaseDecisionTypesPresenter extends TLoadingAwarePresenter {
  caseDecisionTypes: IDocumentType[];
}

export interface ICaseDecisionTypesPresenter
  extends TCaseDecisionTypesPresenter,
    TPresentable {
  loadAllCaseDecisionTypes(caseDecisionTypes: IDocumentType[]): void;
  createCaseDecisionType(data: IDocumentType): void;
  updateCaseDecisionType(data: IDocumentType): void;
}

const defaultState: TCaseDecisionTypesPresenter = { caseDecisionTypes: [] };

const CaseDecisionTypesPresenter = withStore<
  ICaseDecisionTypesPresenter,
  TCaseDecisionTypesPresenter
>(({ application, store, loader, translate }): ICaseDecisionTypesPresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<
    TCaseDecisionTypesPresenter & TLoadingAwarePresenter
  >();
  loader.start("caseDecisionTypeLoader");
  const loadAllCaseDecisionTypes = (caseDecisionTypes: IDocumentType[]) => {
    _store.update({ caseDecisionTypes });
    loader.stop("caseDecisionTypeLoader");
  };

  const getAllCaseDecisionTypes = async () => {
    let caseDecisionTypes = await _application.container
      .resolve<GetAllCaseDecisionTypesInteractor>("getAllCaseDecisionTypes")
      .execute();
    loadAllCaseDecisionTypes(caseDecisionTypes);
  };

  const createCaseDecisionType = async (caseDecisionType: IDocumentType) => {
    await _application.container
      .resolve<CreateCaseDecisionTypeInteractor>("createCaseDecisionType")
      .execute(caseDecisionType);
    _application.container
      .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
      .execute(translate("editors.project_member.create_success_message"));

    await getAllCaseDecisionTypes();
  };
  const updateCaseDecisionType = async (caseDecisionType: IDocumentType) => {
    await _application.container
      .resolve<UpdateCaseDecisionTypeInteractor>("updateCaseDecisionType")
      .execute(caseDecisionType);
    _application.container
      .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
      .execute(translate("editors.project_member.create_success_message"));

    await getAllCaseDecisionTypes();
  };

  return {
    ...state,
    store: _store,
    loader,
    application: _application,
    translate,
    loadAllCaseDecisionTypes,
    createCaseDecisionType,
    updateCaseDecisionType
  };
}, defaultState);

export default CaseDecisionTypesPresenter;
